import cookie from "./_cookie";
import {initSlider} from "./slider";

const recent = document.querySelector('.js-get-recently');

if (recent) {
    if(cookie.get('recently-viewed') !== null) {
        async function fetchProducts() {
            const currentProducts = cookie.get('recently-viewed').split(',').filter(p => p.trim());
            let validProductsCount = 0;

            for (const currentProduct of currentProducts) {
                try {
                    const response = await fetch(`/products/${currentProduct}?section_id=product-block-by-id`);
                    
                    if (!response.ok) {
                        continue;
                    }
                    
                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    
                    const productData = doc.querySelector('.js-product-data');
                    
                    if (productData && productData.innerHTML.trim()) {
                        recent.insertAdjacentHTML('beforeend', productData.innerHTML);
                        validProductsCount++;
                    }

                } catch (error) {
                    console.error(error);
                }
            }

            if (validProductsCount === 0) {
                document.querySelector('.js-get-recently-viewed').classList.add('d-none');
                return;
            }

            const Slider = recent.closest('.js-slider');

            if(Slider) {
                initSlider(Slider);
            }

        }
        fetchProducts();
    } else {
        document.querySelector('.js-get-recently-viewed').classList.add('d-none');
    }



}

export const recentProducts = (newProduct, max = 10, days = 14) => {

    let currentProducts = cookie.get('recently-viewed');

    if (currentProducts && currentProducts !== ''){

        const products = currentProducts.split(',').filter(p => p.trim());
        const index = products.indexOf(newProduct);

        if (index !== -1) {
            products.splice(index, 1);
        }

        products.unshift(newProduct);
        products.splice(max);
        cookie.set('recently-viewed', products.join(','), days);

    } else {
        cookie.set('recently-viewed', newProduct, days);
    }
}